import React from "react";
import { AccountBalanceWalletRounded } from "@mui/icons-material";

const Header = () => {
  return (
    <div className="flex ml-[5px]">
      <AccountBalanceWalletRounded className="text-primary" />
      <span className="text-gray-500 font-medium ml-[4px] uppercase text-[18px]">
        Credit Customer
      </span>
    </div>
  );
};

export default Header;
